module.exports = __webpack_public_path__ + "img/professional_templates.19cdf4e4.svg";